var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25156 9.97501L16.9116 4.42301C18.6116 3.61301 20.3856 5.38801 19.5766 7.08901L14.0246 18.748C13.2656 20.341 10.9656 20.243 10.3456 18.59L9.31956 15.851C9.21931 15.5838 9.06303 15.3412 8.86123 15.1393C8.65942 14.9375 8.41676 14.7813 8.14956 14.681L5.40956 13.654C3.75756 13.034 3.65856 10.734 5.25156 9.97501Z",
    stroke: "#4F7942",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoActive);
export default __webpack_public_path__ + "static/media/geoActive.d6ef0fce0655f4cf2b196a96036a1ddf.svg";
export { ForwardRef as ReactComponent };